<template>
  <div>
    <div class="d-flex align-items-center justify-content-between">
      <legend>Locations</legend>

      <div class="d-flex align-items-center w-100 justify-content-end">
        <span class="font-weight-bold font-size-12 mr-3">
          Facility Location
        </span>

        <div class="custom-control custom-switch custom-switch-text custom-control-inline custom-switch-color mr-0">
          <div class="custom-switch-inner">
            <input
                type="checkbox"
                class="custom-control-input bg-info"
                id="status"
                v-model="showLocations"
            >
            <label class="custom-control-label" for="status"></label>
          </div>
        </div>
      </div>
    </div>

    <!-- FORM -->
    <div v-if="!showLocations" class="m-0">
      <div
          class="d-flex gap-2 position-relative mb-2"
          v-for="(location, key) in allLocations"
          :key="key"
      >
        <input-form
            style="flex: 1;"
            v-model="location.name"
            placeholder="Location Name"
            :validate="'required|max:50'"
            name="name"
            :limit="50"
        />

        <input-form
            style="flex: 1;"
            v-model="location.link"
            placeholder="Location Link"
            :validate="'required|max:50'"
            name="link"
            :limit="50"
        />

        <span
            v-if="key !== 0"
            class="text-danger deleteLabelButton cursor-pointer"
            style="top:-20px"
            @click="deleteLocation(key)"
        >
          Delete
        </span>
      </div>

      <p class="d-flex justify-content-end m-0">
        <span class="text-warning cursor-pointer" @click="addNewLocation">
          + Add new location
        </span>
      </p>
    </div>

    <!-- MESSAGE -->
    <p v-else class="font-weight-bold text-black italic font-size-20">
      We will take your facility location *
    </p>
  </div>
</template>

<script>
export default {
  name: 'Location',

  props: {
    allLocations: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      // initial value
      showLocations: true
    }
  },

  mounted () {
    // لو جاي بيانات من السيرفر يبقى افتح الفورم
    if (this.allLocations && this.allLocations.length) {
      this.showLocations = false
    }
  },
  watch: {
    showLocations (val) {
      this.$emit('facility_location', +val)

      if (!val && !this.allLocations.length) {
        this.$emit('locations', [{ name: '', link: '' }])
      }
    }
  },

  methods: {
    addNewLocation () {
      this.$emit('locations', [
        ...this.allLocations,
        { name: '', link: '' }
      ])
    },

    deleteLocation (key) {
      const arr = [...this.allLocations]
      arr.splice(key, 1)
      this.$emit('locations', arr)
    }
  }
}

</script>
